import { e as u, p as d, i as g, n as m, a as h, b as v } from "./update-swiper.mjs";
import { d as x } from "./swiper-core.mjs";
function b(n, i) {
  n === void 0 && (n = {}), i === void 0 && (i = !0);
  const t = {
    on: {}
  }, e = {}, r = {};
  u(t, x), t._emitClasses = !0, t.init = !1;
  const o = {}, s = d.map((a) => a.replace(/_/, "")), l = Object.assign({}, n);
  return Object.keys(l).forEach((a) => {
    typeof n[a] > "u" || (s.indexOf(a) >= 0 ? g(n[a]) ? (t[a] = {}, r[a] = {}, u(t[a], n[a]), u(r[a], n[a])) : (t[a] = n[a], r[a] = n[a]) : a.search(/on[A-Z]/) === 0 && typeof n[a] == "function" ? i ? e[`${a[2].toLowerCase()}${a.substr(3)}`] = n[a] : t.on[`${a[2].toLowerCase()}${a.substr(3)}`] = n[a] : o[a] = n[a]);
  }), ["navigation", "pagination", "scrollbar"].forEach((a) => {
    t[a] === !0 && (t[a] = {}), t[a] === !1 && delete t[a];
  }), {
    params: t,
    passedParams: r,
    rest: o,
    events: e
  };
}
function C(n, i) {
  let {
    el: t,
    nextEl: e,
    prevEl: r,
    paginationEl: o,
    scrollbarEl: s,
    swiper: l
  } = n;
  m(i) && e && r && (l.params.navigation.nextEl = e, l.originalParams.navigation.nextEl = e, l.params.navigation.prevEl = r, l.originalParams.navigation.prevEl = r), h(i) && o && (l.params.pagination.el = o, l.originalParams.pagination.el = o), v(i) && s && (l.params.scrollbar.el = s, l.originalParams.scrollbar.el = s), l.init(t);
}
function S(n, i, t, e, r) {
  const o = [];
  if (!i)
    return o;
  const s = (a) => {
    o.indexOf(a) < 0 && o.push(a);
  };
  if (t && e) {
    const a = e.map(r), c = t.map(r);
    a.join("") !== c.join("") && s("children"), e.length !== t.length && s("children");
  }
  return d.filter((a) => a[0] === "_").map((a) => a.replace(/_/, "")).forEach((a) => {
    if (a in n && a in i)
      if (g(n[a]) && g(i[a])) {
        const c = Object.keys(n[a]), p = Object.keys(i[a]);
        c.length !== p.length ? s(a) : (c.forEach((f) => {
          n[a][f] !== i[a][f] && s(a);
        }), p.forEach((f) => {
          n[a][f] !== i[a][f] && s(a);
        }));
      } else
        n[a] !== i[a] && s(a);
  }), o;
}
const _ = (n) => {
  !n || n.destroyed || !n.params.virtual || n.params.virtual && !n.params.virtual.enabled || (n.updateSlides(), n.updateProgress(), n.updateSlidesClasses(), n.parallax && n.params.parallax && n.params.parallax.enabled && n.parallax.setTranslate());
};
export {
  S as a,
  b as g,
  C as m,
  _ as u
};
//# sourceMappingURL=update-on-virtual-data.mjs.map
